import React from 'react';
import { QuickFiltersSettingsPage } from '@atlassian/jira-software-board-settings-quick-filters';

export const LazyQuickFiltersSettingsSpa = () => <QuickFiltersSettingsPage />;

export default LazyQuickFiltersSettingsSpa;
